import { Component } from '@theme/component';

export class EventSlider extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#init();
  }

  #init() {
    const slider = this.querySelector('[data-event-slider]');
    if (!slider) return;

    this.slides = slider.querySelectorAll('[data-event-slide]');
    if (this.slides.length === 0) return;

    // Get settings
    this.autoplay = slider.getAttribute('data-autoplay') === 'true';
    this.autoplaySpeed = parseInt(slider.getAttribute('data-autoplay-speed') || '2') || 2;
    this.currentIndex = 0;
    this.autoplayInterval = null;
    this.isMobile = window.innerWidth <= 749;
    this.manuallyStopped = false;

    // Setup
    this.#setupEvents();
    this.#setActive(0);
    
    // Start autoplay if needed
    if (this.isMobile || this.autoplay) {
      this.#startAutoplay();
    }
  }

  #setupEvents() {
    // Click on slides
    if (this.slides) {
      this.slides.forEach((slide, index) => {
        slide.addEventListener('click', () => {
          this.#setActive(index);
          this.#stopAutoplay();
          this.manuallyStopped = true;
          
          // On mobile, always resume autoplay after a short delay
          if (this.isMobile) {
            setTimeout(() => {
              this.#startAutoplay();
              this.manuallyStopped = false;
            }, 2000); // Resume after 2 seconds
          }
        });
      });
    }

    // Hover pause only on active slide (desktop only)
    if (!this.isMobile && this.slides) {
      this.slides.forEach((slide, index) => {
        slide.addEventListener('mouseenter', () => {
          if (index === this.currentIndex) {
            this.#stopAutoplay();
          }
        });
        
        slide.addEventListener('mouseleave', () => {
          if (index === this.currentIndex && this.autoplay) {
            this.#startAutoplay();
          }
        });
      });
    }

    // Resize handling
    window.addEventListener('resize', () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 749;
      
      if (!wasMobile && this.isMobile) {
        // Switching to mobile - always start autoplay
        this.#startAutoplay();
        this.manuallyStopped = false;
      } else if (wasMobile && !this.isMobile && !this.autoplay) {
        // Switching to desktop and autoplay is disabled
        this.#stopAutoplay();
      }
    });
  }

  /**
   * Set active slide by index
   * @param {number} index - Slide index to activate
   */
  #setActive(index) {
    // Remove active from all
    if (this.slides) {
      this.slides.forEach(slide => slide.classList.remove('active'));
      
      // Add active to current
      if (this.slides[index]) {
        this.slides[index].classList.add('active');
        this.currentIndex = index;
      }
    }
  }

  #startAutoplay() {
    this.#stopAutoplay();
    
    const delay = (this.autoplaySpeed || 2) * 1000;
    
    this.autoplayInterval = setInterval(() => {
      if (this.slides && this.slides.length > 0) {
        const nextIndex = (this.currentIndex + 1) % this.slides.length;
        this.#setActive(nextIndex);
      }
    }, delay);
  }

  #stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#stopAutoplay();
  }
}

if (!customElements.get('event-slider')) {
  customElements.define('event-slider', EventSlider);
}